module.exports = __webpack_public_path__ + "static/media/scene4_furba2.0fb88420.wav";